import MockWrite from './MockWrite'

export default MockWrite